import { render } from '@wordpress/element';

import './style.scss';
import Style from './Style';
import Gallery from './Gallery';

// Pricing Tables
document.addEventListener('DOMContentLoaded', () => {
	const allImageGallery = document.querySelectorAll('.wp-block-bigb-image-gallery');
	allImageGallery.forEach(imageGallery => {
		const attributes = JSON.parse(imageGallery.dataset.attributes);
		const { cId, gallery, slideSpeed, columns } = attributes;

		render(<>
			<Style attributes={attributes} clientId={cId} />

			<div className='bigbImageGallery'>
				<Gallery gallery={gallery} slideSpeed={slideSpeed} columns={columns} />
			</div>
		</>, imageGallery);

		imageGallery?.removeAttribute('data-attributes');
	});
});